/* eslint-disable no-useless-escape */
export function resolveAbsoluteUrl(baseUrl: string, relativeUrl: string): string {
  if (isAbsoluteUrl(relativeUrl)) {
    return relativeUrl;
  }

  if (isBase64Url(relativeUrl)) {
    return relativeUrl;
  }

  return relativeUrl ? new URL(relativeUrl, baseUrl).href : baseUrl;
}

export function isAbsoluteUrl(url: string): boolean {
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
}

/**
 * Judge whether the url is base64 url.
 * @param url - The url to be judged.
 * @returns Whether the url is base64 url.
 */
export function isBase64Url(url: string): boolean {
  return /^data:.*,.*$/i.test(url);
}

export function jumpToModelOptimizerPage(name?: string, model?: Blob) {
  const modelOptimizerUrl =
    window.location.hostname === 'twin.easyv.cloud'
      ? 'https://model.easyv.cloud'
      : 'http://model.easyv.test';
  const handle = window.open(modelOptimizerUrl, '_blank', model ? undefined : 'noreferrer');
  if (!handle) {
    return;
  }

  const handleMessage = (e: MessageEvent) => {
    if (e.origin === modelOptimizerUrl && e.data.msg === 'success') {
      handle.postMessage(
        {
          type: 'file',
          name,
          file: model,
        },
        modelOptimizerUrl,
      );
      window.removeEventListener('message', handleMessage);
    }
  };

  window.addEventListener('message', handleMessage, false);
}
